const SHOW_DIALOD = 'SHOW_DIALOD';
const HIDE_DIALOD = 'HIDE_DIALOD';

export default {
  SHOW_DIALOD,
  HIDE_DIALOD
};



// WEBPACK FOOTER //
// ./src/stores/dialog/_types.js